(function() {
    'use strict';

    angular.module('app.areas', []);
})();
